import deepmerge from "@node/deepmerge";

let locales = {};

const modules = import.meta.glob("@o-din-ku/../../config/locales/**/*.yml", { eager: true });

for (const path in modules) {
  locales = deepmerge(locales, modules[path].default);
}

import store from "@o-din-ku/src/ku/store";
import menu from "@o-din-ku/src/ku/menu.json";

export default {
  routes: [
    { path: "/ku/equipments", component: () => import("./views/ku/equipments/Index.vue") },
    { path: "/ku/equipments/new", component: () => import("./views/ku/equipments/Form.vue") },
    { path: "/ku/equipments/:id/edit", component: () => import("./views/ku/equipments/Form.vue") },
    { path: "/ku/equipments/:id", component: () => import("./views/ku/equipments/ConsumptionChart.vue") },
    { path: "/ku/equipments/qr_print", component: () => import("./views/ku/equipments/Qr.vue"), name: 'EquipmentsQr' },
    { path: "/ku/equipment_types", component: () => import("./views/ku/equipment_types/Index.vue") },
    { path: "/ku/equipment_types/new", component: () => import("./views/ku/equipment_types/Form.vue") },
    { path: "/ku/equipment_types/:id/edit", component: () => import("./views/ku/equipment_types/Form.vue") },
    { path: "/ku/equipment_types/:id", component: () => import("./views/ku/equipment_types/Show.vue") },
    { path: "/ku/additional_equipments", component: () => import("./views/ku/additional_equipment/Index.vue") },
    { path: "/ku/additional_equipments/new", component: () => import("./views/ku/additional_equipment/Form.vue") },
    { path: "/ku/additional_equipments/:id/edit", component: () => import("./views/ku/additional_equipment/Form.vue") },
    { path: "/ku/additional_equipments/:id", component: () => import("./views/ku/additional_equipment/Show.vue") },
    { path: "/ku/equipment_data", component: () => import("./views/ku/equipment_datum/Index.vue") },
    { path: "/ku/equipment_data/new", component: () => import("./views/ku/equipment_datum/Form.vue") },
    { path: "/ku/equipment_data/:id/edit", component: () => import("./views/ku/equipment_datum/Form.vue") },
  ],
  locales,
  store,
  menu: [menu]
};
